import { BASE_URL, BASE_SOCKET_URL, JWT_APP_ID } from '../../config/URL'
import axios from 'axios'
import { showToastNotif } from './notification'
import { generateErrorDetail } from '../../utils'

const URL_INTERACTIVE = `${BASE_URL}/catalog/v1.1/liveChannels`
const URL_COMMENTS = `${BASE_URL}/catalog/v1.1/liveChannel`
const SOCKET_URL = `${BASE_SOCKET_URL}/interaction/v1/comments`

export const getInteractive = (page = 1, perPage = 20) => async (
  dispatch,
  getState
) => {
  const state = getState()
  const { data } = state.interactive;

  dispatch({
    type: 'GET_INTERACTIVE'
  })

  try {
    if (data < 1) {
      const res = await axios.get(
      `${URL_INTERACTIVE}?interactive=true&page=${page}&perPage=${perPage}&locale=en`,
      {
        headers: {
          Authorization: state.auth.token,
          'Cloudfront-JWT-AppId': JWT_APP_ID
        }
      }
      )
             
      dispatch({
        type: 'GET_INTERACTIVE_SUCCESS',
        payload: {
          ...res.data
        },
        page
      })
    }else {
      dispatch({
         type: 'GET_INTERACTIVE_SUCCESS_FROM_STATE',
         payload: {
           ...state.interactive,
         },
         page,
       });
    }
    } catch (err) {
      const errorData = generateErrorDetail(err);
      dispatch(showToastNotif('error', errorData.message));
      dispatch({
        type: 'GET_INTERACTIVE_FAILURE',
        err: errorData
      })
  }
}

export const getComments = (channelID, limit) => async (
  dispatch,
  getState
) => {
  try {
    const res = await axios.get(
      `${URL_COMMENTS}/${channelID}/comments?limit=${limit}`,
    )

    dispatch({
      type: 'SET_COMMENTS',
      payload: {
        data: res.data && res.data.data
      }
    })
  } catch (err) {
    const errorData = generateErrorDetail(err);
    dispatch(showToastNotif('error', errorData.message));
    dispatch({
      type: 'GET_INTERACTIVE_FAILURE',
      err: errorData
    })
  }
}

function waitForSocketConnection(socket, callback) {
  setTimeout(
    function () {
      if (socket.readyState === 1) {
        console.log("Connection is made")
        if (callback != null) {
          callback();
        }
      } else {
        console.log("wait for connection...")
        waitForSocketConnection(socket, callback);
      }

    }, 5); // wait 5 milisecond for the connection...
}

export const connectSocket = (channelID, userToken) => (dispatch, getState) => {
  const ws = new WebSocket(`${SOCKET_URL + '/' + channelID}`)
  ws.onopen = () => console.log("connected to server")
  ws.onclose = e => console.log(`socket closed`, e.reason)
  ws.onerror = err => {
    console.error(err.message)
    ws.close()
  }
  ws.onmessage = event => {
    const message = JSON.parse(event.data)
    message.type === "comment" && dispatch({
      type: 'ADD_COMMENT',
      payload: { data: message }
    })
    message.type === "viewers" && dispatch({
      type: 'SET_VIEWS',
      payload: { data: parseInt(message.data) }
    })
  }
  return ws
}

export const sendAuth = (ws, token) => () => {
  waitForSocketConnection(ws, () => {
    const payload = { type: "authorization", data: token }
    ws.send(JSON.stringify(payload))
  })
}

export const addComment = (ws, comment) => () => {
  waitForSocketConnection(ws, () => {
    const payload = { type: "comment", data: comment }
    ws.send(JSON.stringify(payload))
  })
}

export const resetInteractive = () => (dispatch, getState) => {
  dispatch({
    type: 'RESET_INTERACTIVE'
  })
}